import { create } from "zustand";
import { ICampaign } from "./CampaignInterface";

export interface CampaignState {
  campaigns: ICampaign[];
  setCampaigns: (applications: ICampaign[]) => void;
}

const useCampaignStore = create<CampaignState>((set) => ({
  campaigns: [],
  setCampaigns: (campaigns) => set(() => ({ campaigns })),
}));

export default useCampaignStore;
